import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from 'app/services/notification/notification.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  constructor(public readonly notification: NotificationService) {}

  ngOnInit(): void {}
  ngOnDestroy(): void {
    this.notification._state;
  }
}
